/* Edits the state whenever xmlFile event triggers */

export function xmlSourceFetchHasErrored(state = false, action) {
	switch (action.type) {
	case 'XML_SOURCE_LOAD_FAILED':
		return action.hasErrored;
	default:
		return state;
	}
}
export function xmlSourceFetchIsLoading(state = false, action) {
	switch (action.type) {
	case 'XML_SOURCE_ISLOADING':
		return action.isLoading;
	default:
		return state;
	}
}
export function xmlSourceFile(state = [], action) {
	switch (action.type) {
	case 'XML_SOURCE_LOADED':
		return action.file;
	default:
		return state;
	}
}
